import { render, staticRenderFns } from "./AppTable.pug?vue&type=template&id=2c401ce1&scoped=true&lang=pug&"
import script from "./AppTable.vue?vue&type=script&lang=js&"
export * from "./AppTable.vue?vue&type=script&lang=js&"
import style0 from "./AppTable.scss?vue&type=style&index=0&id=2c401ce1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c401ce1",
  null
  
)

export default component.exports